import React, { useCallback } from 'react'

import { FormHelpersProviderReturn, FieldSettings, Address } from '../../../ana-toolbox'
import { AddressField } from '../../components/address-field/address-field'
import { getIsRequired } from '../helpers/getIsRequired'
import { combinedFields } from '../yup/main'

const streetField: FieldSettings = combinedFields.street

export const AddressLayoutItem: React.FC<{ formHelpers: FormHelpersProviderReturn; field?: FieldSettings }> = ({
  formHelpers: { setFieldValue },
  field = streetField,
}) => {
  const handleReceiveAddress = useCallback(
    (address: Address) => {
      setFieldValue('zipCode', address.zipCode)
      setFieldValue('city', address.city)
      setFieldValue('addressGoogleVerified', true)
    },
    [setFieldValue]
  )

  return (
    <AddressField
      name={field.name}
      label={field.label}
      required={getIsRequired(field.isRequired)}
      helperText={field.justificativeTooltipText}
      placeholder={field.inputProps?.placeholder}
      onReceiveAddress={handleReceiveAddress}
    />
  )
}
